/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenGenericIcon20Regular = forwardRef('TechScreenGenericIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.249 3.001a3.25 3.25 0 0 0-3.25 3.25v5.498a3.25 3.25 0 0 0 3.25 3.25h9.502a3.25 3.25 0 0 0 3.25-3.25V6.25a3.25 3.25 0 0 0-3.25-3.25H5.25Zm-1.75 3.25c0-.966.783-1.75 1.75-1.75h9.502c.967 0 1.75.784 1.75 1.75v5.498a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75V6.25Z" }),
        React.createElement("path", { d: "M5.5 16.25a.75.75 0 1 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z" })));
});
